import * as React from 'react';
import * as ReactTooltip from 'react-tooltip';

import { localization } from '../../../shared/localization/localization';
import { IPrintData} from '../tron-editor-api';
import { IBrandingTechnology } from '../tron-editor-interfaces';
import { Markdown } from 'src/App/shared/localization/markdown-wrapper';

export interface ILogoEditorPrintAreaProps {
    colorsInMotive: number;
    printData: IPrintData;
    selectedBrandingTechnology: IBrandingTechnology | null;
}

class LogoEditorPrintAreaComponent extends React.Component<ILogoEditorPrintAreaProps> {
    constructor(props: ILogoEditorPrintAreaProps) {
        super(props);
    }

    private getColorInfo(): JSX.Element {
        if (this.props.selectedBrandingTechnology 
            && (this.props.selectedBrandingTechnology.effectType === "EMBOSS"
            || this.props.selectedBrandingTechnology.effectType === "LASER")) {
            return (
                <div className="colors-info">
                    <div className="actual-motive-colors">
                        <Markdown text={localization.editorLoc.logoEditorContent.colorlessTechnology} />
                    </div>
                </div>
            )
        }

        if (this.props.printData
            && this.props.printData.maxColors) {
            // show max technology colors colors vs motive colors
            const isOverMax: boolean = this.props.colorsInMotive > +this.props.printData.maxColors;
            return (
                <div className={"colors-info " + (isOverMax ? "colors-info-error" : "colors-info-ok")} data-tip={true} data-for="colors-exceeded">
                    <div className="max-motive-colors">
                        <Markdown text={localization.formatString(
                            localization.editorLoc.logoEditorContent.maxMotiveColors,
                            `<b>${this.props.printData.maxColors}</b>`
                        ) as string}/>
                    </div>
                    <div className="actual-motive-colors">
                        <span className="warn-icon">&#9888;</span>
                        <span>
                            <Markdown text={localization.formatString(
                                localization.editorLoc.logoEditorContent.actualMotiveColors,
                                `<b>${this.props.colorsInMotive}</b>`
                            ) as string}/></span>
                    </div>
                    <ReactTooltip id="colors-exceeded" effect={'solid'} place={'bottom'} disable={!isOverMax}>
                        <div style={{maxWidth: 200}}>{localization.editorLoc.logoEditorContent.toolTips.colorsExceeded}</div>                    
                    </ReactTooltip>
                </div>
            )
        } else {
            // show just number of colors in motive
            return (
                <div className="colors-info">
                    <div className="actual-motive-colors">
                        <Markdown text={localization.formatString(
                            localization.editorLoc.logoEditorContent.actualMotiveColors,
                            `<b>${this.props.colorsInMotive}</b>`
                        ) as string}/>
                    </div>
                </div>
            )
        }
    }

    private getPrintInfo(): JSX.Element {
        let pPos; let pTech;
        if (this.props.printData.posName) {
            pPos = <div>
                <Markdown text={localization.formatString(
                    localization.editorLoc.logoEditorContent.printPositionLabel,
                    `<b>${this.props.printData.posName}</b>`,
            ) as string}/></div>
        }
        if (this.props.printData.techName) {
            pTech = <div>
                <Markdown text={localization.formatString(
                    localization.editorLoc.logoEditorContent.printTechnologyLabel,
                    `<b>${this.props.printData.techName}</b>`,
                ) as string}/></div>
        }

        return (<div className="technology-info">
            {pPos}
            {pTech}
        </div>);
    }

    private getSizeInfo(): JSX.Element {
        return (<div className="motive-size-info">
            <div className="max-motive-size">
                <Markdown text={localization.formatString(
                    localization.editorLoc.logoEditorContent.printAreaSize,
                    `<b>${this.props.printData.areaWidth}</b>`,
                    `<b>${this.props.printData.areaHeight}</b>`,
                ) as string} />
            </div>
            <div className="actual-motive-size">
                <Markdown text={localization.formatString(
                    localization.editorLoc.logoEditorContent.motiveAreaSize,
                    `<b>${this.props.printData.motiveWidth}</b>`,
                    `<b>${this.props.printData.motiveHeight}</b>`,
                    (this.props.printData.motiveWidth * this.props.printData.motiveHeight / 100).toFixed(2)
                ) as string} />
            </div>
        </div>);
    }

    public render() {
        return (
            <div className="editor-print-area-root">
                {this.getPrintInfo()}
                {this.getColorInfo()}
                {this.getSizeInfo()}
            </div>
        );
    }
}

export const LogoEditorPrintArea = (props: ILogoEditorPrintAreaProps) => <LogoEditorPrintAreaComponent {...props} />



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-position.component.tsx